module.exports = function(posts) {
	'use strict'
	posts.directive('croppieDir',croppieDir);
	croppieDir.$inject=['getDataService','$rootScope','activeClass','refreshtokenService','config','$timeout','postDataService','serverError','alertService','$compile','offlineError'];
	function croppieDir(getDataService,$rootScope,activeClass,refreshtokenService,config,$timeout,postDataService,serverError,alertService,$compile,offlineError) {
		return {
			restrict: 'E',
			scope: {
		      src: '=',
		      ngModel: '=',
		      postObj:'='
		    },
		    link: function (scope, element, attrs) {
			    if(!scope.src) return;
			    scope.imgWidth = scope.postObj.featured_img_obj.meta.width;
			    scope.imgHeight = scope.postObj.featured_img_obj.meta.height;
		    	var state = "attachments";
		    	var loader = angular.element(document.getElementById('loader.html')).html();
			     $timeout(function() {
	                element.after($compile(loader)(scope));
	             },0);
		    	scope.init = false;
	    		var boundaryHeight;
	      	var boundaryWidth;
		    	var viewportHeight;
					var viewportWidth;
					var browserWidth = window.innerWidth;
					boundaryWidth = 600;
					if(browserWidth < 650) {
					boundaryWidth = browserWidth - 40; 
					}
					console.log(browserWidth);
					var croppieInitFunction = function(width,height) {
						scope.loaderImageShow = true;
						viewportHeight = boundaryWidth/2*height/width;
							viewportWidth = boundaryWidth/2*width/height;
							scope.c = new Croppie(element[0], {
								viewport: {
										width: (scope.imgWidth < scope.imgHeight ? boundaryWidth/2 : viewportWidth),
										height: (scope.imgWidth < scope.imgHeight ? viewportHeight :boundaryWidth/2)
								},
								boundary: { 
									width: boundaryWidth, 
									height: boundaryWidth
								},
								update: function () {
										scope.c.result('canvas').then(function(img) {
											scope.$apply(function () {
												scope.ngModel = img;
											});
										});
								},
								enableZoom : false,
								showZoomer: false,
							});

						// bind an image to croppie
							scope.c.bind({
								url: scope.src
						}).then(function(data) {
							scope.loaderImageShow = false;
							scope.$apply();
						});
						
					}
					scope.$on('set-area', function(event, data) {
						if(scope.init) {
							scope.c.destroy();
						}
						scope.init = true;
						croppieInitFunction(data.ratio.width,data.ratio.height);
						scope.cropWidth = data.ratio.width;
						scope.cropHeight = data.ratio.height;
						scope.cropUrl = data.url;
						if(scope.cropUrl) {
							scope.file_name = scope.cropUrl.replace(/^.*[\\\/]/, '');
						}
					});
					var postCordianteFunction = function(id) {
						$timeout(function() {
							var coordinatesUpdate = scope.c.get().points;
						var cropData = {
							'selection': {
								'x': coordinatesUpdate[0],
								'y': coordinatesUpdate[1],
								'x2': (coordinatesUpdate[2] > scope.imgWidth)? scope.imgWidth: coordinatesUpdate[2],
								'y2': (coordinatesUpdate[3] > scope.imgHeight)? scope.imgHeight: coordinatesUpdate[3]  
							},
							'raw_values': {
								'id': id,
								'width': scope.imgWidth,
								'height': scope.imgHeight
							},
							'active_values': {
								'name': 'img-'+scope.cropWidth+'x'+scope.cropHeight,
								'width': scope.cropWidth,
								'height': scope.cropHeight,
								'ratio': scope.cropHeight/scope.cropWidth,
								'file_name': scope.file_name		  					
							}
						}
						console.log(cropData);
						var postFunction = function() {	
							postDataService.save({
									param1:state,
									param2:'crop',
								},cropData).$promise.then(function(data){
									scope.postObj.featured_img_obj.thumbs = data.attachment;
									$rootScope.hasLoaded = true;
										alertService('success','Success ', data.message, 2000);
								}, function(error){
									if(!window.navigator.onLine) {
										offlineError()
										$rootScope.hasLoaded = true;
										alertService('danger','Opps! ', 'Please check your internet connection and try again.');
										return
									}
									if(error.status ==401) {
										var promise = refreshtokenService.getAccessToken();
										promise.then(
											function(answer) {
												if(answer==200) {
													postFunction();
												}
											},
											function(error) {
												// report something
											},
											function(progress) {
												// report progress
										});
									} else if(error.status ==502) {
										serverError()
									} else {
										alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
									}
									$rootScope.hasLoaded = true;
							});
						}
						$rootScope.hasLoaded = false;
						postFunction();
						},0)
					}
					scope.$on('crop-image', function(event, data) {
						var id = data.id;
						var coordinates = scope.c.get().points;
						postCordianteFunction(id);
					});
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/postsModule/edit-newpost/js/directive/croppieDirective.js
// module id = 556
// module chunks = 0